import { render, staticRenderFns } from "./lazyblock_rules.vue?vue&type=template&id=c83e0d0c&scoped=true"
import script from "./lazyblock_rules.vue?vue&type=script&lang=js"
export * from "./lazyblock_rules.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_rules.vue?vue&type=style&index=0&id=c83e0d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83e0d0c",
  null
  
)

export default component.exports